<template>
    <div :class="$style['review-goods']">
        <table>
            <pt-form-list-item label="上架时间:" :required="true">
                <wt-radio :radios="reviewTimeSelect" v-model="type" data-vv-as="上架时间" name="name"  v-validate="'required'"></wt-radio>
            </pt-form-list-item>
            <pt-form-list-item v-if="this.type !== 'now'" label="设定至:" :required="true">
                <el-date-picker type="datetime" value-format="timestamp" v-model="form.putOnSaleTime" data-vv-as="设定上架时间" name="name"  v-validate="'required'"></el-date-picker>
            </pt-form-list-item>
        </table>
        <div :class="$style['button-div']">
            <el-button type="primary" @click="submit" :loading="loading">确认</el-button>
            <el-button type="primary" plain  @click="cancel">取消</el-button>
          </div>
    </div>
</template>
<script>
import { reviewTimeSelect } from './review-options'
import formMixins from 'mixins/form'
export default {
  name: 'review-goods',
  mixins: [formMixins],
  props: {
    goodsDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    fromPage: String
  },
  data () {
    return {
      reviewTimeSelect: reviewTimeSelect,
      type: 'now',
      form: {
      },
      loading: false
    }
  },
  methods: {
    submit () {
      this.form.specifyTime = this.type !== 'now'
      this.form.id = this.goodsDetail.goodsDTO && this.goodsDetail.goodsDTO.id
      if (!this.form.specifyTime) {
        delete this.form.putOnSaleTime
      }
      this.loading = true
      let apiUrl = this.fromPage === 'integral' ? 'integralGoodsPublish' : 'goodsPublish'
      this.validate().then(formVue => {
        this.$store.dispatch(apiUrl, this.form).then(res => {
          this.loading = false
          this.form = {}
          this.$set(this, 'form', {})
          this.$emit('closeDialog', true)
        }).catch(err => {
          this.loading = false
          this.$message.error(err || '审核商品上架失败')
        })
      })
    },
    cancel () {
      this.form = {}
      this.$set(this, 'form', {})
      this.$emit('closeDialog')
    }
  },
  created () {
  }
}
</script>
<style module lang="less">
.button-div{
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
}
</style>
